/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable react/no-unescaped-entities */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import ViewForm from './DocumentLoad';
import { dataService } from '../../services/data.service';
import ApplicationContext from '../../context/ApplicationContext';
import BackButton from '../../components/Button/BackButton';
import NextButton from '../../components/Button/NextButton';
import { reviewLanguageContent } from '../Review/reviewLanguageContent';
import { documentsLanguageContent } from './documentsLanguageContent';
import ViewComponents from './DocumentLoad/ViewComponents';
import RingProgress from '../../components/RingProgress';

function DocumentsMain(props) {
    const { sessionData, handlePage, setLoading, insurances, selectedLanguage, mergeFieldValues, setMergeFieldValues } = useContext(ApplicationContext);
    const [showFullView, setShowFullView] = useState(false);
    const [selectedChoice, setSelectedChoice] = useState('');
    const [currentDocumentIndex, setCurrentDocumentIndex] = useState((sessionData?.document_session?.document_index) - 1 || 0);
    const [documents, setDocuments] = useState('');
    const [packetData, setPacketData] = useState('');
    const [loader, setLoader] = useState(false);
    const [currentDocumentID, setCurrentDocumentID] =  useState('');
    const [documentType, setDocumentType] = useState('');
    const [documentStatus, setDocumentStatus] = useState('Pending');
    const [dataDocumentPercent, setDataDocumentPercent] = useState(null);
    const [completedPercentage, setCompletedPercentage] = useState(0);
    const [isUpdated, setIsUpdated] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [componentAnswers, setComponentAnswers] = useState({});

    let [pages, setPages] = useState([]);
    let [droppedComponents, setDroppedComponents] = useState([]);

    const handleBackNavigation = () => {
        if(sessionData['review'] === 'previous') {
            handlePage('review');
        }  else {
            if(insurances.length > 0) {
                setLoading(true);
                handlePage('insurance_details');
            } else {
                handlePage('insurance')
            }
        }
    }

    const handleDocumentLoad = () => {
        dataService.listQueuedDocuments(sessionStorage.getItem('session')).then((res) => {
            if(res.error === false) {
                const merge_fields = {
                    ...res?.data?.patient_data,
                    ...res?.data?.facility_data,
                }
                setMergeFieldValues(merge_fields)
                if(res.data.data.length > 0) {
                    setDocuments(res.data.data);
                    if(!res.data.data[currentDocumentIndex]) {
                        let documentSession = {
                            document_index: 0,
                            current_document_id: '',
                        }
                        if(sessionData.is_signature_document_exist === true) {
                            handlePage('signature', '', '', sessionData['review'] === 'previous' ? 'previous' : '', null, null, documentSession)
                        } else {
                            handlePage('review', '', '', sessionData['review'] === 'previous' ? 'previous' : '', null, null, documentSession)
                        }
                        return;
                    }
                    setSelectedChoice(res.data.data[currentDocumentIndex].acknowledged_answer);
                    setDocumentType(res.data.data[currentDocumentIndex].document_type);
                    setDocumentStatus(res.data.data[currentDocumentIndex].status);
                    let currentID = sessionData.document_session.current_document_id;
                    if(!currentID) {
                        currentID = res.data.data[0].form_id
                    }
                    setCurrentDocumentID(currentID);
                    setPageLoading(false);
                } else {
                    let documentSession = {
                        document_index: 0,
                        current_document_id: '',
                    }
                    setPageLoading(false);
                    handlePage('review', '', '', sessionData['review'] === 'previous' ? 'previous' : '', null, null,documentSession)
                }
            }
        })
    };

    useEffect(() => {
        //Add a validation here for Opt out
        // if(sessionData?.patient_details?.is_opt_out) {
        //     handlePage('review')
        //     return;
        // }
        if(documents.length === 0) {
            handleDocumentLoad();
        }
    }, []);

    const handleNextNavigation = (form) => {
        setLoader(true);
        const payload = {
            "form_id": form.form_id,
            "acknowledged_answer": selectedChoice,
        }
        dataService.acknowledgeDocument(form.source_packet_id || form._id, payload).then((res) => {
            setLoading(true);
            setLoader(false);
            if(res.error === false) {
                if(sessionData?.document_session?.document_index === documents.length) {
                    if(sessionData.is_signature_document_exist === true) {
                        handlePage('signature', '', '', sessionData['review'] === 'previous' ? 'previous' : '')
                    } else {
                        handlePage('review', '', '', sessionData['review'] === 'previous' ? 'previous' : '')
                    }
                } else {
                    let documentSession;
                    let currentSession = sessionData.document_session;
                    documentSession = {
                        document_index: currentSession.document_index + 1,
                        current_document_id: documents[currentSession.document_index].form_id,
                    }
                    handlePage('documents', '', '', sessionData['review'] === 'previous' ? 'previous' : '', null, null,documentSession)
                }
            }
        })
    }


    const getPercentageCompleted = () => {
        let percent = 0;
        switch(documentType) {
        case 'Information': if(selectedChoice !== '') {
            percent = 100
        }
            break;
        case 'Signature': if(documentStatus === 'Completed') {
            percent = 100
        } else if(selectedChoice !== '')  {
            percent = 50
        }
            break;
        case 'Data': 
            if(dataDocumentPercent) {
                let completed = dataDocumentPercent.completed_components_count;
                if(selectedChoice !== '') {
                    completed = completed + 1
                }
                percent = (completed/(dataDocumentPercent.total_components_count + 1)) * 100
            }
            break;
        default: if(selectedChoice !== '') {
            percent = 100
        }
        }
        setCompletedPercentage(percent)
        return percent
    }

    useEffect(() => {
        getPercentageCompleted()
    }, [dataDocumentPercent, selectedChoice])

    return (
        <>
            {pageLoading ?
                <div className='absolute z-[9] w-full top-[100px] flex flex-col justify-between doc-height'>
                    <div>
                        <div className='flex justify-between items-center py-2 px-[20px] border-y border-[#70B503]'>
                            <div className='flex items-center w-[70%]'>
                                <div className='bg-slate-300 animate-pulse w-full h-[20px] rounded-lg' />
                            </div>
                        </div>
                    </div>
                </div>
                :
                documents.length > 0 && documents.map((item, index = 0) => (
                    currentDocumentID === item.form_id  && 
                    <div key={`document-${index + 1}`} className='absolute z-[9] w-full top-[100px] flex flex-col justify-between doc-height'>
                        <div data-testid={`document_${currentDocumentIndex}`}>
                            {<RingProgress percentage={completedPercentage} />}
                            <div className='flex justify-between items-center py-2 px-[20px] border-y border-[#70B503]'>
                                <div className='flex items-center w-[70%]'>
                                    <span className={`bg-[#007EB4] rounded-[50%] h-[25px] py-0.5 px-2 text-sm text-[#F2F2F2] mr-3`}>{sessionData?.document_session?.document_index}</span>
                                    <p className='text-sm font-semibold'>{item.form_name || item.name}</p>
                                </div>
                                <button data-testid={`${showFullView ? 'hide_entire_form' : 'show_entire_form'}`} onClick={() => setShowFullView(!showFullView)} className={`${showFullView ? 'bg-[#025478]' : 'bg-[#333]'} text-[#F2F2F2] px-[12px] py-[6px] flex items-center rounded-full w-auto font-semibold text-base`}>
                                    {showFullView ? <img src="/images/hide.svg" className='mr-[10px]' alt="hide" /> : <img src="/images/View.svg" className='mr-[10px]' alt="view" />}
                                    {showFullView ? reviewLanguageContent['hide'][selectedLanguage] : reviewLanguageContent['view'][selectedLanguage]}
                                </button>
                            </div>
                            <div className={`p-[8px] mb-5 ${showFullView ? 'hidden' : ''}`} data-testid="simplified-view">
                                <div className={`flex ${selectedLanguage === 'ar' ? 'items-end' : 'items-center'} flex-col border-b border-[#D7D7D7] pb-[10px] mx-[18px]`}>
                                    {documentsLanguageContent['use-view'][selectedLanguage]}
                                    <p className='text-[#333333] text-sm font-normal flex justify-center'><img src="/images/form-required.svg" alt="required" className='mr-2' /> {documentsLanguageContent['indicates'][selectedLanguage]}</p>
                                </div>
                                <ViewComponents pages={pages} setPages={setPages} droppedComponents={droppedComponents} setDroppedComponents={setDroppedComponents} componentAnswers={componentAnswers} setComponentAnswers={setComponentAnswers}
                                    isUpdated={isUpdated} setIsUpdated={setIsUpdated} dataDocumentPercent={dataDocumentPercent} setDataDocumentPercent={setDataDocumentPercent} currentDocumentID={currentDocumentID} formData={item} selectedChoice={selectedChoice} selectedLanguage={selectedLanguage} item={item} setSelectedChoice={setSelectedChoice} />
                            </div>
                            <div className={`${showFullView ? '' : 'hidden'}`}>
                                <ViewForm componentAnswers={componentAnswers} setComponentAnswers={setComponentAnswers} pages={pages} setPages={setPages} droppedComponents={droppedComponents} setDroppedComponents={setDroppedComponents} isUpdated={isUpdated} packetData={packetData} isPacketForm={packetData.is_document_packet ? true : false} formData={item} />
                            </div>
                        </div>
                        {!showFullView && <div className={`flex mb-[24px] ${sessionData?.document_session?.document_index === 1 ? 'justify-between' : 'justify-end ml-[200px]'} mx-[16px] w-auto fold-gap gap-[12px]`}>
                            {sessionData?.document_session?.document_index === 1 && <BackButton disabled={loader} handleClick={() => handleBackNavigation()} backType="cancel" />}
                            <NextButton loader={loader} disabled={(selectedChoice === '' && item.acknowledged_answer === '') || (documentType === 'Data' && dataDocumentPercent?.incomplete_required_fields !== 0) || loader} handleClick={() => handleNextNavigation(item)} />
                        </div>}
                    </div>
                ))}
        </>
        
        
    );
}

export default DocumentsMain;